module.exports = __webpack_public_path__ + "img/general.dd7193fb.svg";